import styled from 'styled-components';

import {
  Control as commonControl,
  ValueContainer as commonValueContainer,
  SelectContainer as commonSelectContainer,
  Placeholder as commonPlaceholder,
  SingleValue as commonSingleValue,
  Input as commonInput,
  Menu as commonMenu,
  MenuList as commonMenuList,
  Option as commonOption,
  IndicatorSeparator as commonIndicatorSeparator,
  IndicatorsContainer as commonIndicatorsContainer,
  NoOptionsMessage as commonNoOptionsMessage,
  DropdownIndicator as commonDropdownIndicator,
  DropdownIndicatorIcon as commonDropdownIndicatorIcon,
  MultiValueContainer as commonMultiValueContainer,
  MultiValueLabel as commonMultiValueLabel,
  Checkbox as commonCheckbox,
  CheckboxInput as commonCheckboxInput,
  CheckboxCheckmark as commonCheckboxCheckmark,
  Radio as commonRadio,
  RadioInput as commonRadioInput,
  RadioCheckmark as commonRadioCheckmark,
} from '../../assets/Common/Select.style';

export const Control = styled.div`
  ${commonControl}
`;

export const ValueContainer = styled.div`
  ${commonValueContainer}
`;

export const SelectContainer = styled.div`
  ${commonSelectContainer}
`;

export const Placeholder = styled.div`
  ${commonPlaceholder}
`;

export const SingleValue = styled.div`
  ${commonSingleValue}
`;

export const Input = styled.div`
  ${commonInput}
`;

export const Menu = styled.div`
  ${commonMenu}
`;

export const MenuList = styled.div`
  ${commonMenuList}
`;

export const Option = styled.div`
  ${commonOption}
`;

export const IndicatorSeparator = styled.div`
  ${commonIndicatorSeparator}
`;

export const IndicatorsContainer = styled.div`
  ${commonIndicatorsContainer}
`;

export const NoOptionsMessage = styled.div`
  ${commonNoOptionsMessage}
`;

export const DropdownIndicator = styled.div`
  ${commonDropdownIndicator}
`;

export const DropdownIndicatorIcon = styled.i`
  ${commonDropdownIndicatorIcon}
`;

export const MultiValueContainer = styled.div`
  ${commonMultiValueContainer}
`;

export const MultiValueLabel = styled.span`
  ${commonMultiValueLabel}
`;

export const Checkbox = styled.div`
  ${commonCheckbox}
`;

export const CheckboxInput = styled.input`
  ${commonCheckboxInput}
`;

export const CheckboxCheckmark = styled.i`
  ${commonCheckboxCheckmark}
`;

export const Radio = styled.div`
  ${commonRadio}
`;

export const RadioInput = styled.input`
  ${commonRadioInput}
`;

export const RadioCheckmark = styled.i`
  ${commonRadioCheckmark}
`;
